"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var WindowItemPosAttributes_1 = require("../model/WindowItemPosAttributes");

var WindowItemPosAttributesConverter_1 = require("./WindowItemPosAttributesConverter");
/**
 * Default implementation of WindowItemPosAttributesConverter.
 *
 * @author ZSr
 */


var WindowItemPosAttributesConverterImpl =
/*#__PURE__*/
function (_WindowItemPosAttribu) {
  _inherits(WindowItemPosAttributesConverterImpl, _WindowItemPosAttribu);

  function WindowItemPosAttributesConverterImpl() {
    _classCallCheck(this, WindowItemPosAttributesConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPosAttributesConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemPosAttributesConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowItemPosAttributes_1.WindowItemPosAttributes(WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posActionFlag.valueOfField(source), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posMechanics.valueOf(index_1.Utils.isValueMissing(source.posMechanics) ? null : source.posMechanics), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posType.valueOf(index_1.Utils.isValueMissing(source.posType) ? null : source.posType), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posMultiBuyVariant.valueOf(index_1.Utils.isValueMissing(source.posMultiBuyVariant) ? null : source.posMultiBuyVariant), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posDiscountPerPiece.valueOf(index_1.Utils.isValueMissing(source.posDiscountPerPiece) ? null : conversions.toBigNumber(source.posDiscountPerPiece)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posGiftId.valueOf(index_1.Utils.isValueMissing(source.posGiftId) ? null : conversions.toClassReferenceId(source.posGiftId)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posGiftPrice.valueOf(index_1.Utils.isValueMissing(source.posGiftPrice) ? null : conversions.toBigNumber(source.posGiftPrice)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posGiftPreviousPrice.valueOf(index_1.Utils.isValueMissing(source.posGiftPreviousPrice) ? null : conversions.toBigNumber(source.posGiftPreviousPrice)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posGiftForecast.valueOf(index_1.Utils.isValueMissing(source.posGiftForecast) ? null : conversions.toBigNumber(source.posGiftForecast)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posGiftDistrModelId.valueOf(index_1.Utils.isValueMissing(source.posGiftDistrModelId) ? null : conversions.toClassReferenceId(source.posGiftDistrModelId)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posDistributionModelDays.valueOf(index_1.Utils.isValueMissing(source.posDistributionModelDays) ? null : source.posDistributionModelDays), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posMarginImpactTheoretical.valueOf(index_1.Utils.isValueMissing(source.posMarginImpactTheoretical) ? null : conversions.toBigNumber(source.posMarginImpactTheoretical)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posMarginImpactExpected.valueOf(index_1.Utils.isValueMissing(source.posMarginImpactExpected) ? null : conversions.toBigNumber(source.posMarginImpactExpected)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posRedemption.valueOf(index_1.Utils.isValueMissing(source.posRedemption) ? null : conversions.toBigNumber(source.posRedemption)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        posActionFlag: source.posActionFlag,
        posMechanics: index_1.Utils.isValueMissing(source.posMechanics) ? null : source.posMechanics,
        posType: source.posType,
        posMultiBuyVariant: index_1.Utils.isValueMissing(source.posMultiBuyVariant) ? null : source.posMultiBuyVariant,
        posDiscountPerPiece: index_1.Utils.isValueMissing(source.posDiscountPerPiece) ? null : conversions.fromBigNumber(source.posDiscountPerPiece),
        posGiftId: index_1.Utils.isValueMissing(source.posGiftId) ? null : conversions.toDocumentReferenceId(source.posGiftId),
        posGiftPrice: index_1.Utils.isValueMissing(source.posGiftPrice) ? null : conversions.fromBigNumber(source.posGiftPrice),
        posGiftPreviousPrice: index_1.Utils.isValueMissing(source.posGiftPreviousPrice) ? null : conversions.fromBigNumber(source.posGiftPreviousPrice),
        posGiftForecast: index_1.Utils.isValueMissing(source.posGiftForecast) ? null : conversions.fromBigNumber(source.posGiftForecast),
        posGiftDistrModelId: index_1.Utils.isValueMissing(source.posGiftDistrModelId) ? null : conversions.toDocumentReferenceId(source.posGiftDistrModelId),
        posDistributionModelDays: index_1.Utils.isValueMissing(source.posDistributionModelDays) ? null : source.posDistributionModelDays,
        posMarginImpactTheoretical: conversions.fromBigNumber(source.posMarginImpactTheoretical),
        posMarginImpactExpected: conversions.fromBigNumber(source.posMarginImpactExpected),
        posRedemption: conversions.fromBigNumber(source.posRedemption)
      });
      return result;
    }
  }]);

  return WindowItemPosAttributesConverterImpl;
}(WindowItemPosAttributesConverter_1.WindowItemPosAttributesConverter);

exports.WindowItemPosAttributesConverterImpl = WindowItemPosAttributesConverterImpl;